var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KPI-dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Ride-Final-Copy-4",
    transform: "translate(-551.000000, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(549.822740, 297.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_circle_exclamation",
    fill: "#D32F2F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z M13,13 L13,6 L11,6 L11,13 L13,13 Z M11,16.0064935 C11,16.2965382 11.0916927,16.5346311 11.2750809,16.7207792 C11.4584691,16.9069273 11.7011851,17 12.0032362,17 C12.3009724,17 12.5415309,16.9069273 12.7249191,16.7207792 C12.9083073,16.5346311 13,16.2965382 13,16.0064935 C13,15.7121197 12.9072285,15.4707802 12.7216828,15.2824675 C12.5361372,15.0941549 12.2966573,15 12.0032362,15 C11.7055001,15 11.4638628,15.0941549 11.2783172,15.2824675 C11.0927715,15.4707802 11,15.7121197 11,16.0064935 Z",
    id: "shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWarningRed);
export default __webpack_public_path__ + "static/media/ico_warning_red.c384d1cab01f7029d758729dfd8d8b5a.svg";
export { ForwardRef as ReactComponent };